import React from 'react';
import {connect} from 'react-redux'
import {Flex, SVGButton} from '/app/src/component';
import style from './style.css';
import SVG from 'react-inlinesvg';
import Theme from '/app/src/theme';
import { history } from '/app/src/store';


class Post extends React.Component {
    constructor(props) {
        super(props);
        this.mouseEnter = this.mouseEnter.bind(this)
        this.mouseLeave = this.mouseLeave.bind(this)
        this.state = {
            hover: false
        }
    }

    mouseEnter() {
        this.setState({hover: true})
    }

    mouseLeave() {
        this.setState({hover: false})
    }

    _renderOptions() {
        const {faqId, categoryId} = this.props;

        return (
            <Flex className={style.OptionsWrapper} hAlignContent='right'>
                <Flex className={style.Options} bg='mediumgrey' center>
                        <SVGButton className={style.OptionsIcon}
                            src='/images/GoToEdit_M.svg'
                            onClick={(e)=>{
                                e.stopPropagation();
                                history.push('/clientChat/faq/helpdesk/category/'+categoryId+'/update/'+faqId);
                                }
                            }
                            color={Theme.colors.black} h='55px' hover='blue'/>
                </Flex>
            </Flex>
        )
    }

    render() {
        const {rating} = this.props

        return (
            <Flex className={style.PostContainer} w='100%' shrink={0}>
                <Flex width='30px' shrink={0}>
                    { rating === 1 ?
                        <SVG style={{'fill': Theme.colors.green1, width: '30px'}} src='/images/emojiSmile1.svg' cacheGetRequests={true}/>
                        : <SVG style={{fill: Theme.colors.red1, width: '30px'}} src='/images/emojiUnhappy.svg' cacheGetRequests={true}/>
                    }
                </Flex>
                <Flex grow bg={'grey1'} className={style.PostBox} w='100%'>
                    {this._renderPost()}
                </Flex>
            </Flex>
        )
    }

    _renderPost() {
        const {hover} = this.state
        const {question, dateCreated, feedbackText, onClick, isRead, isSelected} = this.props
        const titleStyle = isRead ? style.IsReadTitle : style.Title;
        const bodyTextStyle = isRead ? style.IsReadBodyText : style.BodyText;
        let border = {border: '3px solid transparent'};

        if(isSelected){
            border = {border: '3px solid #2ea2d2', borderRadius: '0px 40px 40px 40px'}
        }

        return (
            <Flex
                onMouseEnter={this.mouseEnter}
                onMouseLeave={this.mouseLeave}
                onClick={onClick}
                column
                position='relative' w='100%'
                style={border}
                className={style.BorderBox}>
                {hover && this._renderOptions()}
                <Flex column className={style.PostBlock} shrink={0}>
                    <Flex className={style.Header} grow shrink={0}>
                        <Flex className={titleStyle}>
                            <Flex shrink={0} w='25px'>
                                <Flex height='25px'>
                                <SVG
                                    style={{'fill': Theme.colors.black, width: '16px', marginTop: '2px'}}
                                    src='/images/ArrowRight_S.svg' cacheGetRequests={true}/>
                                </Flex>
                            </Flex>
                            <Flex grow>
                                <Flex grow className={style.QuestionTitle}>
                                    {question}
                                </Flex>
                            </Flex>
                        </Flex>
                        <Flex className={style.Date} color='lightblack' shrink={0}>
                            {dateCreated}
                        </Flex>
                    </Flex>
                    <Flex className={bodyTextStyle} shrink={0}>
                        {feedbackText}
                    </Flex>
                </Flex>
            </Flex>
        )

    }
}

function mapStateToProps() {
    return {}
}
export default connect(mapStateToProps)(Post)



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Helpdesk/Feedback/Posts/Post/index.js